<ng-container [formGroup]="bookingForm">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Site Rules & Policies</ion-card-title>
      <div class="optional-rift-soft">Recommended</div>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <h4>Site rules and policies</h4>
        <div>
          All guest must adhere to
          <a [routerLink]="['', 'terms']" class="link"> CurbNTurf rules and polices </a>
          and any rules set by the host.
        </div>
        <div class="_6-px-spacer"></div>
        <div class="horz-line"></div>
        <div class="_18-px-spacer"></div>

        <curbnturf-listing-rules [form]="policiesForm"> </curbnturf-listing-rules>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="listing">
    <ion-card-header>
      <ion-card-title>Set Cancellation Policy</ion-card-title>
      <div *ngIf="!listingComplete.cancellationCompleted(cancellationPolicy.value)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="listingComplete.cancellationCompleted(cancellationPolicy.value)"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <div class="title-information-wrapper">
          <h4>
            <label for="cancellationPolicy">
              Select the cancellation policy that you&rsquo;d like to use for the site.
            </label>
          </h4>
        </div>

        <ng-select
          class="dropdown listing w-dropdown dropdown-toggle"
          id="cancellationPolicy"
          [formControl]="cancellationPolicy"
          [clearable]="false"
          placeholder="Select a Cancellation Policy"
        >
          <ng-option
            *ngFor="let cancellationPolicyOption of cancellationPolicyOptions | enumSelector"
            [value]="cancellationPolicyOption.key"
          >
            {{ cancellationPolicyOption.value }}
          </ng-option>
        </ng-select>

        <curbnturf-cancellation-policy-list
          *ngIf="cancellationPolicy?.value"
          [policy]="cancellationPolicy?.value"
          [showAll]="true"
        >
        </curbnturf-cancellation-policy-list>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="listing">
    <ion-card-header>
      <ion-card-title>Set Bookings & Check-in Windows</ion-card-title>
      <div *ngIf="!listingComplete.bookingCompleted(bookingForm.value)" class="required-pill ion-float-end">
        <p class="paragraph">required</p>
      </div>
      <curbnturf-checked *ngIf="listingComplete.bookingCompleted(bookingForm.value)"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-listing-booking [form]="bookingForm"> </curbnturf-listing-booking>
      </div>
    </ion-card-content>
  </ion-card>
</ng-container>
